<template lang='slm'>
  .text-center.bg-white.pb-4.pt-4 v-if='$apollo.loading'
    .container
      h1 Loading...
  .text-center.bg-white.pb-4.pt-4 v-else-if='!currentUser'
    .container
      .jumbotron
        vue-telegram-login mode='redirect' telegramLogin='MltChurchBot' redirectUrl='/api/login' radius='3' size='large'
        a.btn.btn-info.mt-3 v-if='devEnvironment' href='/api/login?fake=true' Fake login
  div v-else=''
    .section.pt-4.pb-4.bg-white
      a.my-btn.mb-3 href='/api/logout' Выйти
      h1 Привет, {{ currentUser.name }}!
    template v-if='currentUser.allowedEntities'
      .section.pt-2.pb-2 style='background-color:#F7F7F7'
        h2 Карусель
        admin-carousel
      .section.pt-2.pb-2 style='background-color:#F2F2F2'
        h2 Аудиопроповеди
        admin-audio-preachings
      .section.pt-2.pb-2 style='background-color:#F7F7F7'
        h2 Музыка
        admin-albums
    template v-if='currentUser.allowedQuestions'
      .section.pt-2.pb-2 style='background-color:#F2F2F2'
        h2 Анонимные вопросы
        admin-questions :current-user='currentUser'
</template>

<style lang='stylus'>
// WARNING! global styles
img.preview
  max-width 200px
  box-shadow 0 0 10px gray
td
  vertical-align middle !important
</style>

<script>
import VueTelegramLogin from '@/components/TelegramLogin';
import gql from 'graphql-tag';
import AdminCarousel from './_AdminCarousel';
import AdminAudioPreachings from './_AdminAudioPreachings';
import AdminAlbums from './_AdminAlbums';
import AdminQuestions from './_AdminQuestions';

const GET_CURRENT_USER_QUERY = gql`query { currentUser { id name allowedQuestions allowedEntities } }`;

export default {
  name: 'AdminPage',
  components: {
    VueTelegramLogin, AdminCarousel, AdminAudioPreachings, AdminAlbums, AdminQuestions,
  },
  data() {
    return {
      devEnvironment: process.env.NODE_ENV !== 'production',

      currentUser: null,
    };
  },
  apollo: {
    currentUser: {
      query: GET_CURRENT_USER_QUERY,
      client: 'admin',
    },
  },
};
</script>
